import { faker } from '@faker-js/faker';
import { devices } from './devices';

const selectedDevices = [
  faker.helpers.arrayElement(devices),
  faker.helpers.arrayElement(devices)
];

const COMMENTS = [
  'Замена картриджа UV',
  'Замена картриджа RO',
  'Замена картриджа Mineral',
  'Замена картриджа GAC-PP',
  'Замена картриджа PP1',
  'Замена картриджа GAC',
  'Замена картриджа PP5',
  ''
];

export const auditLogs = {
  Items: faker.helpers.uniqueArray(
    () => {
      const device = faker.helpers.arrayElement(selectedDevices);
      return {
        Id: faker.string.nanoid(),
        DeviceId: device.Id,
        EventName: 'MaintenanceCompleted',
        CreatedAt: Date.now(),
        UserId: '0000a818-b917-467a-8f9c-1aefd7753ac0',
        EventData: {
          Comment: faker.helpers.arrayElement(COMMENTS)
        },
        address: device.Info.Address
      };
    },
    faker.number.int({ min: 1, max: 10 })
  )
};
